import { j as a } from "../../../jsx-runtime-BwWtxLpl.js";
import k from "classnames";
import c from "prop-types";
import { useState as e } from "react";
import { FormFieldProvider as w } from "./form-field.context.js";
const z = ({ children: m, className: d = "", ...u }) => {
  const [p, x] = e(!1), [t, h] = e(null), [s, g] = e(null), [f, v] = e(!1), [I, F] = e(""), [b, P] = e(""), [y, E] = e(!1), [T, j] = e(!1), [S, A] = e(null), [i, H] = e(!1), [o, M] = e(!1), [N, q] = e(!1), [l, C] = e(!1), [r, L] = e(!1), R = (n) => {
    M(typeof n == "boolean" ? n : !o);
  }, V = k({
    "motif-form-field": !0,
    "motif-form-field-focused": o,
    "motif-form-field-has-placeholder": s,
    "motif-form-field-has-value": i,
    "motif-form-field-select-input": t === "selectInput",
    "motif-form-field-text-input": t === "textInput",
    "motif-form-field-text-area-input": t === "textAreaInput",
    "motif-form-field-date-input": t === "dateInput",
    "motif-form-field-icon-prefix": l,
    "motif-form-field-icon-suffix": r,
    "motif-form-field-has-label": f,
    [d]: !0
  }), D = {
    disabled: p,
    formElementType: t,
    hasContent: i,
    hasPlaceholder: s,
    id: I,
    idErrorMessage: b,
    invalid: y,
    isFocused: o,
    isActive: N,
    required: T,
    value: S,
    iconPrefix: l,
    iconSuffix: r,
    setDisabled: x,
    hasLabel: f,
    setActive: q,
    setFormElementType: h,
    setHasContent: H,
    setHasPlaceholder: g,
    setId: F,
    setIdErrorMessage: P,
    setInvalid: E,
    setRequired: j,
    setValue: A,
    setIconPrefix: C,
    setIconSuffix: L,
    setHasLabel: v,
    toggleFocus: R
  };
  return /* @__PURE__ */ a.jsx(w, { value: D, children: /* @__PURE__ */ a.jsx("div", { ...u, className: V, "data-motif-form-field": !0, role: "group", children: m }) });
};
z.propTypes = {
  children: c.node,
  className: c.string
};
export {
  z as MotifFormField
};
